import { Component, Input, OnInit } from "@angular/core";
import { ReportDescription } from "../../../reports/interfaces/report.interface";
import { reportDescription } from "../../../reports/report-descriptions";
import { QuestionConfig, QuestionTypeConfig, QuestionViewType } from "../../interfaces/process-config.interface";
import { UntypedFormGroup } from "@angular/forms";
import { BaseClass } from "../../classes/base";
import { ModalController, ToastController } from "@ionic/angular";
import { TranslationService } from "../../services/translation.service";
import * as moment from "moment/moment";
import { Goal } from "src/app/goals/_interfaces/goal.interface";
import { SelfEvaluationRecord } from "src/app/self-evaluation/_interfaces/self-evaluation-record.interface";
import { ViewGoalsPage } from "src/app/dashboard/goals-progress/view-goals/view-goals.page";
import { UtilService } from "../../services/util.service";
import { ConfigService } from "src/app/shared/services/multi-clients/config.service";
import { ConceptsDescriptionModalComponent } from "../concepts-description/concepts-description-modal.component";
import { TextAlertModal } from "src/app/shared/modals/text-alert/text-alert-modal.component";

@Component({
    selector: "app-question-types",
    templateUrl: "./question-types.component.html",
    styleUrls: ["./question-types.component.scss"],
})
export class QuestionTypesComponent extends BaseClass implements OnInit {
    public readonly QuestionViewType = QuestionViewType;

    @Input() question: QuestionConfig;
    @Input() formGroup: UntypedFormGroup;
    @Input() hideQuestionTitle: boolean = false;
    @Input() isManagerComment: boolean = false;
    @Input() managerAnswer: boolean = false;

    @Input() evaluation?: SelfEvaluationRecord = null;
    @Input() goalsIndexes?: Array<{ id: number; index: number }> = [];

    public questionsType: any;
    public reportDescriptions: { [key: string]: ReportDescription } = reportDescription;
    public descriptionTooltip: string = "";

    constructor(
        protected _toastController: ToastController,
        protected _translationService: TranslationService,
        private _modalController: ModalController,
        private _utilService: UtilService,
        private _configService: ConfigService
    ) {
        super(_toastController, _translationService);
    }
    ngOnInit(): void {
        this.questionsType = this._configService.settings.features.questionTypeAvailability.question;
    }
    public async setRangeValue(key: string, value: string, typeConfig?: QuestionTypeConfig, index?: number): Promise<void> {
        const control = this.formGroup.get(key);

        if (control.value !== value && typeConfig !== null && typeConfig.confirmationTextEnabled && typeConfig.confirmationTextEnabled[index] === true) {
            let language = this._translationService.getSelectedLanguage();
            const confirmationSliderTextModal = await this._modalController.create({
                component: TextAlertModal,
                cssClass: "medium-text-alert",
                componentProps: {
                    evaluationType: null,
                    closeButtonHeader: null,
                    headerText: null,
                    contentText: typeConfig.confirmationText[language][index],
                    leftOption: { text: "generic.cancel", signal: false },
                    rightOption: { text: "generic.confirm", signal: true },
                },
            });

            confirmationSliderTextModal.onDidDismiss().then((dismissEvent) => {
                if (dismissEvent.data) {
                    if (!control.disabled) {
                        control.value !== value ? control.setValue(value) : control.setValue(undefined);
                    }
                }
            });

            await confirmationSliderTextModal.present();
        } else {
            if (!control.disabled) {
                control.value !== value ? control.setValue(value) : control.setValue(undefined);
            }
        }
    }

    public getQuestionAnswer(question: QuestionConfig, gIndex: number): string {
        if (this.goalsIndexes) {
            if ((question.attributes && question.attributes.length > 0) || question.hasQuestionAttributes) {
                return this._utilService.getEvaluationValue(
                    question,
                    this.evaluation,
                    this.goalsIndexes,
                    gIndex ? question.groupedIndexes[gIndex] : question.currentIndex,
                );
            }
            return this._utilService.getEvaluationValue(question, this.evaluation, this.goalsIndexes, gIndex + question.currentIndex);
        }

        return gIndex ? this.evaluation["field" + question.groupedIndexes[gIndex]] : this.evaluation["field" + question.currentIndex];
    }

    public showRequiredBadge(formGroup: UntypedFormGroup, index: number): boolean {
        const res = formGroup["missingFields"] && !formGroup.get("field" + index + (this.isManagerComment ? "Comment" : "")).valid;
        return res;
    }

    public async openDescriptionConcept(title: string, description: string, index: number) {
        const modal = await this._modalController.create({
            component: ConceptsDescriptionModalComponent,
            cssClass: "smaller-modal",
            componentProps: { title: title[index], data: description[index] },
        });

        await modal.present();
    }

    public setTooltip(question: QuestionConfig, vIndex: number) {
        this.descriptionTooltip = this.getDescription(question, vIndex);
    }

    private getDescription(question: QuestionConfig, index: number): string {
        let selectedLanguage: string = this._translationService.getSelectedLanguage();
        if (question && question.typeConfig && question.typeConfig.description && question.typeConfig.description[selectedLanguage][index])
            return question.typeConfig.description[selectedLanguage][index];
        return "";
    }
}
